var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-start",on:{"click":function($event){return _vm.goBack()}}},[_c('div',{staticClass:"header-button"},[_c('chevron-left-icon',{attrs:{"size":"18"}})],1),_vm._v(" "),_c('h1',{staticClass:"page-title link"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f80296fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/b122/BackArrow.vue
// module id = iJ2X
// module chunks = 1